import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { getToken } from '@/utils/auth' // get token from cookie
import { authUrl } from '@/config/Settings'
import { titleConfig } from '@/utils'

import NotFound from '@/components/NotFound'
import Home from '@/views/Home'
import My from '@/views/my/index' 
import messageRouters from './message'
import myOfferRouters from './myOffer'
import ForgetPwd from '@/views/login/forgetPwd'

import Login from '@/views/login' 

Vue.use(VueRouter)

// 基础页面路由，不需要权限控制也能访问
export const baseRoutes = [
  {
    path: '*',
    component: NotFound,
    hidden: true,
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: '首页'
    },
    hidden: true,
  }, 
  {
    path: '/enquiry/enquiryDetail',
    name: 'enquiryDetail',
    component: () => import('@/views/enquiry/enquiryDetail'),
    meta: {
      title: '询价详情'
    }, 
  },
  {
    path: '/my',
    name: 'my',
    component: My,
    meta: {
      title: '我的'
    },
    hidden: true,
  },   
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: '登录'
    },
    hidden: true,
  },
   {
    path: '/login/forgetPwd',
    name: 'forgetPwd',
    component: ForgetPwd,
    meta: {
      title: '登录'
    },
    hidden: true,
  },
  ...messageRouters,
  ...myOfferRouters
]

// 需要权限控制的页面路由
export const authRoutes = [
  
]

const routerConfig = {
  mode: 'history',
  base: process.env.NODE_ENV === 'development' ? '' : '',
  routes: baseRoutes,  
}
const router = new VueRouter(routerConfig)

const loginUrlArray = ['/login', '/auth-redirect'];
const whiteList = ['/login','/login/forgetPwd','/forgetPwd', '/auth-redirect'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  const title = to.query.navbarTitle || to.meta.title
  if (title) {
    // 设置 navTab 标题
    to.meta.title = title
    // 设置页面标题
    titleConfig(title)
  }
  // 白名单内不用校验
  if (whiteList.indexOf(to.path) !== -1) { 
    next()
    return
  }
  const token = getToken()
  if (token) {
    if (loginUrlArray.indexOf(to.path) !== -1) {
      // 已登录状态下访问登录页，重定向到首页
      next({ path: '/' })
    } else {
      // 检查是否已经获取了用户信息
      const hasRoles = store.getters.permissions && store.getters.permissions.length > 0
      const hasName = store.getters
      // 判断用户信息是否存在
      if ( hasName) {
        next()
      } else {
        try {
          // 获取用户信息及用户权限
          await store.dispatch('user/getInfo') 
          // await store.dispatch('user/getParameters')
          const accessRoutes = await store.dispatch('permission/generateRoutes', ['admin'])
          // debugger
          router.addRoutes(accessRoutes) 
          next({ ...to, replace: true })
        } catch (error) {
          // 移除token并退出登录
          await store.dispatch('user/resetToken')
          // Message.error(error || 'Has Error') 
          // window.location.href = authUrl[process.env.NODE_ENV] + "?callBackUrl=" + window.location.href 
          // NProgress.done()
          next('/login')
        }
      }
    }
  } else {
    // 没有token，重定向到登录页
    next('/login')
  }
})

// 替换现有 router 的 routes
export function resetRouter() {
  router.matcher = new VueRouter(routerConfig).matcher
}

export default router